var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vueper-slides',_vm._g(_vm._b({staticClass:"re-slides"},'vueper-slides',_vm.slidesOptions,false),_vm.$listeners),[_vm._l((_vm.allSlides),function(slide,slideKey){return _c('vueper-slide',_vm._b({key:slideKey},'vueper-slide',_vm.getSlideOptions(slide, slideKey),false))}),_vm._t("default",null,{"slide":"vueper-slide"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }